module.exports = __webpack_public_path__ + "static/media/img_overpaper3@3x.d00b3ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_overpaper3@3x.png
// module id = 966
// module chunks = 0